import { render } from "./PageTitle.vue?vue&type=template&id=e36f2740"
import script from "./PageTitle.vue?vue&type=script&lang=js"
export * from "./PageTitle.vue?vue&type=script&lang=js"

import "./PageTitle.vue?vue&type=style&index=0&id=e36f2740&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__